<a href="javascript:void(0)" (click)="skipToMain()" title="Vai al contenuto della pagina" class="skip-to-main">
	<span>Vai al contenuto della pagina</span>
</a>
<ul class="nav nav-tabs">
	<li class="dropdown alert_proxademp" prossimi-adempimenti></li>

	<li class="dropdown alert_inevase" adempimenti-inevasi></li>

	<li class="dropdown alert_attcomp" attivita-completare></li>

	<li [attr.id]="'notificationsComponent'" class="dropdown alert_notifica" notifications></li>

	<li user class="dropdown loggeduser"></li>
</ul>
